import React from 'react';
import { Col } from 'antd';
import { Button, NpsNumber } from './style';

interface NpsButtonProps {
  number: number;
  color: string;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (_: number) => void;
}

const NpsButton = function ({ number, color, onSubmit }: NpsButtonProps) {
  return (
    <Col>
      <Button
        onClick={() => onSubmit(number)}
        $color={color}
        size="large"
        type="primary"
        tabIndex={0}
      >
        <NpsNumber>{number}</NpsNumber>
      </Button>
    </Col>
  );
};

export default NpsButton;
